var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono_entrada",
    "data-name": "icono entrada",
    transform: "translate(-139 -477)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6765",
    "data-name": "Rect\\xE1ngulo 6765",
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "translate(139 477)",
    fill: "#3f348b",
    opacity: 0.304
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_170333",
    "data-name": "Trazado 170333",
    d: "M12.848,80a2.866,2.866,0,0,1,.225-.333q3.672-3.936,7.346-7.868a1.309,1.309,0,0,1,1.912-.208,1.508,1.508,0,0,1,.235,1.987,3.206,3.206,0,0,1-.291.347q-4.157,4.455-8.316,8.906a1.342,1.342,0,0,1-2.233.011Q9.6,80.562,7.476,78.285a1.515,1.515,0,0,1,.01-2.224,1.259,1.259,0,0,1,1.692-.034,3.447,3.447,0,0,1,.3.294q1.559,1.667,3.116,3.336c.075.08.133.178.251.338",
    transform: "translate(137.11 413.155)",
    fill: "#3f348b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.943d765050d713441c042a26e4294c2d.svg";
export { ForwardRef as ReactComponent };